<template>
    <div
        :class="[
            'Treeselect',
            status !== '' && `Treeselect--${status}`
        ]"
    >
        <template v-if="!isLoading">
            <FieldLabel
                class="Treeselect__label"
                :label="label"
                :label-tooltip="labelTooltip"
                :disabled="disabled"
                :status="status"
            />
            <TreeselectTemp
                :value="value"
                :options="options"
                :multiple="multiple"
                :placeholder="placeholder"
                :disabled="disabled"
                :disable-branch-nodes="disableBranchNodes"
                open-direction="bottom"
                @input="e => $emit('input', e)"
            />
        </template>
    </div>
</template>
<script>
import TreeselectTemp from '@riophae/vue-treeselect';
import stat from 'status';
import FieldLabel from 'components/Basic/Elements/FieldLabel.vue';

export default {
    name: 'RPTreeselect',
    components: {
        TreeselectTemp,
        FieldLabel
    },
    props: {
        label: {
            type: String,
            default: '',
        },
        labelTooltip: {
            type: String,
            default: '',
        },
        options: {
            type: Array,
            required: true,
        },
        value: {
            required: true,
            validator: val => typeof val === 'string'
                    || Array.isArray(val)
                    || val === null
                    || typeof val === 'undefined'
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        placeholder: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        status: {
            type: String,
            default: stat.STANDBY,
        },
        disableBranchNodes: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        isLoading() {
            return this.status === stat.LOADING;
        }
    },
};
</script>
<style src="@riophae/vue-treeselect/dist/vue-treeselect.min.css"></style>
<style lang="scss">
    .Treeselect {
        .vue-treeselect--multi {
            .vue-treeselect__input-container {
                input {
                    border: none;
                    padding: 0;
                }
            }
        }
        @include loading(2rem, 100%);
    }
</style>
